import React, { Component } from "react";
import BasketAdd from "ReactComponents/Basket/basket-add";
import classNames from "classnames";
import IconLogo from "ReactComponents/Shared/Icons/icon-logo";
import * as tracking from "ReactComponents/Shared/Utils/tracking";
import DeliveryCostsModalButton from "ReactComponents/DeliveryCostsModalButton/delivery-costs-modal-button";

class SideBySideProduct extends Component {
    constructor(props) {
        super(props);

        this.productLinkClick = this.productLinkClick.bind(this);

        this.state = {
            isMounted: false
        };
    }

    componentDidMount() {
        this.setState({
            isMounted: true
        });
    }

    handleAuthorclick(e) {
        e.preventDefault();
    }

    productLinkClick() {
        const product = this.props.product;
        tracking.productClick({ product, componentName: "productSlider" });
    }

    render() {
        const product = this.props.product;
        const mediaTypes = this.props.mediaTypes;
        const priceClasses = classNames({
            product__prices: true,
            discounted: product.DiscountedPrice
        });

        return (
            <div className="product-slider__product-item">
                <div className="product__meta-container">
                    <div className="product__img">
                        <a onClick={this.productLinkClick} href={product.ProductPageLink}>
                            {product.CoverImageUrl ? (
                                <img
                                    src={product.CoverImageUrl + "&w=130"}
                                    loading="lazy"
                                    alt={product.Title}
                                />
                            ) : (
                                <div className="product__img--fallback">
                                    <IconLogo />
                                </div>
                            )}
                        </a>
                    </div>

                    <div className="product__titles">
                        <a onClick={this.productLinkClick} href={product.ProductPageLink}>
                            <h3
                                className="product__title"
                                title={product.Title}
                                dangerouslySetInnerHTML={{ __html: product.Title }}
                            />
                            {product.Subtitle && (
                                <div className="product__subtitle">
                                    <span dangerouslySetInnerHTML={{ __html: product.Subtitle }} />
                                </div>
                            )}
                        </a>
                        {/*
                        <div className="product__subtitle">
                            {this.state.isMounted && siteThemeName === "gu" && product.Subtitle && (
                                <span dangerouslySetInnerHTML={{ __html: product.Subtitle }} />
                            )}
                            {this.state.isMounted && siteThemeName !== "gu" && product.EditorsListShort && (
                                <div className="product__editors" onClick={this.handleAuthorclick}>
                                    <span dangerouslySetInnerHTML={{ __html: product.EditorsListShort }} />
                                    <span
                                        className="editor-abbreviation"
                                        dangerouslySetInnerHTML={{
                                            __html: this.props.labels.EditorsListShortAbbreviation
                                        }}
                                    />
                                </div>
                            )}
                            {this.state.isMounted &&
                                siteThemeName !== "gu" &&
                                !product.EditorsListShort &&
                                product.AuthorsListShort && (
                                    <div className="product__authors" onClick={this.handleAuthorclick}>
                                        <span
                                            dangerouslySetInnerHTML={{ __html: product.AuthorsListShort }}
                                        />
                                    </div>
                                )}
                        </div>
                            */}
                    </div>

                    <div className="product__prices-area">
                        <p className="product__price-label">
                            <span
                                className="product__price-label__unit"
                                dangerouslySetInnerHTML={{ __html: product.PriceUnit }}
                            />
                            {product.StockText && (
                                <span
                                    className="product__price-label__stock"
                                    dangerouslySetInnerHTML={{ __html: product.StockText }}
                                />
                            )}
                        </p>

                        <div className="product__price-button-container">
                            <div className={priceClasses}>
                                <p className="product__price-primary">{product.PrimaryPrice}</p>
                                {product.DiscountedPrice && (
                                    <p className="product__price-discount">{product.DiscountedPrice}</p>
                                )}
                                <p className="product__price-secondary">{product.SecondaryPrice}</p>
                            </div>
                        </div>
                        {product.IsPhysical && this.props.productDeliveryInfo && (
                            <DeliveryCostsModalButton productDeliveryInfo={this.props.productDeliveryInfo} />
                        )}
                    </div>

                    <div className="btn-container">
                        {product.CanBeBought ? (
                            <BasketAdd
                                product={product}
                                id={product.Id}
                                label={this.props.labels.AddToBasketText}
                            />
                        ) : (
                            <a
                                className="button button-secondary button--slim button--wide"
                                onClick={this.productLinkClick}
                                href={product.ProductPageLink}
                                dangerouslySetInnerHTML={{ __html: product.ReadMoreText }}
                            />
                        )}
                    </div>
                </div>

                <div className="product__variants">
                    <p
                        className="product__variants__label"
                        dangerouslySetInnerHTML={{ __html: this.props.labels.VariantsLabel }}
                    />
                    <ul className="product__variants__tags">
                        {mediaTypes &&
                            mediaTypes.length > 0 &&
                            mediaTypes.map((item, index) => {
                                return (
                                    <li key={index} className="product-variants__tag">
                                        {item}
                                    </li>
                                );
                            })}
                    </ul>
                </div>
            </div>
        );
    }
}

export default SideBySideProduct;
